import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import useStyles from './style';

interface EventTitleProps extends HTMLAttributes<HTMLHeadElement> {
  className?: string;
  name?: string;
}

const EventTitle: React.FC<EventTitleProps> = ({ className, name = '', ...rest }) => {
  const classes = useStyles();

  return (
    <h3 className={classNames('eventTitle', classes.title, className)} {...rest}>
      {name}
    </h3>
  );
};

export default EventTitle;
